/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online Base64 encoder and decoder. Convert text to and from Base64 with full Unicode (UTF-8) support and an optional URL-safe variant. Nothing is uploaded.`)
};

const es_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador y decodificador Base64 gratuito en línea. Convierte texto de y a Base64 con soporte completo para Unicode (UTF-8) y una variante segura para URL. Nada se carga.`)
};

const de_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Base64-Encoder und -Dekoder. Konvertiere Text zu und von Base64 mit vollständiger Unicode (UTF-8)-Unterstützung und einer optionalen URL-sicheren Variante. Nichts wird hochgeladen.`)
};

const nl_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online Base64 encoder en decoder. Zet tekst om naar en van Base64 met volledige Unicode (UTF-8) ondersteuning en een optionele URL-veilige variant. Niets wordt geüpload.`)
};

const fr_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeur et décodeur Base64 en ligne gratuits. Convertissez du texte en Base64 et vice-versa avec support Unicode complet (UTF-8) et une variante sûre pour les URL en option. Rien n'est téléchargé.`)
};

const it_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore e decodificatore Base64 gratuiti online. Converti il testo in e da Base64 con supporto completo a Unicode (UTF-8) e una variante URL-safe opzionale. Nulla viene caricato.`)
};

const pt_br2_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e decodificador Base64 online gratuito. Converta texto de e para Base64 com suporte completo a Unicode (UTF-8) e uma variante segura para URL opcional. Nada é enviado.`)
};

const pt_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e descodificador Base64 gratuito online. Converta texto para e de Base64 com suporte completo a Unicode (UTF-8) e uma variante segura para URL opcional. Nada é carregado.`)
};

const ja_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインBase64エンコーダーとデコーダー。テキストをBase64への変換と逆変換が可能で、完全なUnicode (UTF-8) 対応とオプションのURL-safe形式に対応しています。何もアップロードされません。`)
};

const zh_b64_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 Base64 编码器和解码器。在文本与 Base64 之间相互转换，完整支持 Unicode（UTF-8），并提供可选的 URL 安全变体。不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_meta_description", locale)
	if (locale === "en") return en_b64_meta_description(inputs)
	if (locale === "es") return es_b64_meta_description(inputs)
	if (locale === "de") return de_b64_meta_description(inputs)
	if (locale === "nl") return nl_b64_meta_description(inputs)
	if (locale === "fr") return fr_b64_meta_description(inputs)
	if (locale === "it") return it_b64_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_b64_meta_description(inputs)
	if (locale === "pt") return pt_b64_meta_description(inputs)
	if (locale === "ja") return ja_b64_meta_description(inputs)
	return zh_b64_meta_description(inputs)
};